import { render } from "./SuccessStoryPage.vue?vue&type=template&id=15e409cb"
import script from "./SuccessStoryPage.vue?vue&type=script&lang=js"
export * from "./SuccessStoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__